import React from "react"
import { useRouteMatch, useHistory } from "react-router-dom"
import { formatRoute } from "react-router-named-routes"
import routes from "../../routes"
import CaseCreationCard from "./"

const CaseCreationCardEnhanced = (props) => {
  const facilityId = useRouteMatch({
    path: "/facility/:facilityId",
  }).params.facilityId
  const history = useHistory()

  const onSuccess = (ctCase) => {
    history.push(
      formatRoute(routes.caseDetail, {
        facilityId: facilityId,
        caseId: ctCase.internalId,
      })
    )
  }

  return <CaseCreationCard onSuccess={onSuccess} {...props} />
}

CaseCreationCardEnhanced.propTypes = {
  patientPositiveTab: CaseCreationCard.propTypes.patientPositiveTab,
  creationComponent: CaseCreationCard.propTypes.creationComponent,
}

export default CaseCreationCardEnhanced
